<template>
  <div class="card">
    <div class="head">
      <h3 class="text-cut-2 my-2">{{ data.chapterName }}/{{ data.name }}/作业</h3>
    </div>
    <div class="topics">
      <div class="topic" v-for="(quest, index) in data.list" :key="index">
        <template v-if="quest.num">
          <h3 class="topic_title">
            {{ quest.typeName }}
            <span>(共{{ quest.num }}题)</span>
          </h3>
          <div :id="'#' + index + '-' + i" class="topic_content" v-for="(item, i) in quest.list" :key="item.id">
            <div class="topic_sub">
              {{ i + 1 }}、
              <p v-html="item.content"></p>
            </div>
            <div class="topic_option pl-4">
              <!-- <div class="topic_item" v-for="(top, idx) in item.list" :key="i + '-' + idx" @click="topic(index, i, top, item)"> -->
              <div class="topic_item" v-for="(top, idx) in item.list" :key="i + '-' + idx" @click="chooseCheck(index, i, top, item)">
                <!-- :class="{'bg_blue': item.myOption.includes(top.letter)}" -->
                <span class="circle" :class="data.done && quest.type === '2' ? top.color : colorStyle(quest.result[i], item, top)">{{ top.letter }}</span>
                <!-- <span class="circle" :class="colorStyle(quest.result[i], item, top)">{{ top.letter }}</span> -->
                <p>{{ top.content }}</p>
              </div>
            </div>
            <div v-if="data.done" class="topic_answer">
              <div style="margin-bottom: 40px;">
                <p class="answer_title">参考答案</p>
                <p class="d-flex">
                  <span class="mr-5">你的答案：{{ quest.result[i].userAnswer || '无' }}</span>
                  <span>正确答案：{{ item.answerOption }}</span>
                </p>
              </div>
              <div>
                <p class="answer_title">答案解析</p>
                <p v-html="item.analysis"></p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          list: [],
          chapterName: '',
          name: '',
          done: false,
        }
      }
    }
  },
  data() {
    return {
    }
  },

  watch: {
    data: {
      handler(newValue, oldValue) {
        console.log('this.data.done', newValue.done)
        console.log('this.data.done', newValue)
        newValue.list.map(item => {
          item.list.map((val, index) => {
            val.quest = item.result[index]
            val.list.map(child => {
              const fatherArr = val.quest.answerOption.split(',').sort()
              const childArr = val.quest.userAnswer ? val.quest.userAnswer.split(',').sort() : []
              if (fatherArr.includes(child.letter)) {
                  child.color = 'bg_red'
                if (childArr.includes(child.letter)) {
                  child.color = 'bg_green'
                }
              }
            })
          })
        })
      },
    }
  },
  computed: {
    colorStyle() {
      let color = ''
      return function(quest, item, { letter }) {
        console.log('this.data.done', this.data.done)
        if (this.data.done) {
          if (letter === quest.answerOption) {
            color = 'bg_green'
          } else if (letter === quest.userAnswer) {
            color = 'bg_red'
          } else {
            color = ''
          }
        } else {
          color = item.myOption.includes(letter) ? 'bg_blue' : ''
        }
        return color
      }
    }
  },
  methods: {
    handleIncludes(childArr, fatherArr) {
      var userA = childArr
      var answerO = fatherArr
      for (var i = 0; i < userA.length; i++) {
        if (!answerO.includes(userA[i])) {
          return false
        }
      }
      return true
    },
    topic(i1, i2, { letter }) {
      // console.log('data.list', this.data.list)
      // console.log('i1', i1)
      // console.log('i2', i2)
      console.log('letter', letter)
      console.log('')
      const arr = []
      arr.push(letter)
      // const dataTest = new Set(letter)
      // console.log('dataTest', dataTest)
      console.log('arr', arr)
      // console.log('this.data.done', this.data.done)

      if (this.data.done) return
      this.$emit('checked', { i1, i2, letter })
    },

    chooseCheck(dataIndex, quesIndex, itemData, questItem) {
      console.log('itemData--', itemData.content)
      if (questItem.type === '2') {
        questItem.list.map(val => {
          console.log('val---', val.content)
          if (itemData.content === val.content) {
            val.checked = !val.checked
          }
          console.log('val---checked', val.checked)
        })
        const multipleChoice = questItem.list.filter(item => {
            if (item.checked) {
              return item
            }
        })
        const multipleChoiceRes = multipleChoice.map(item => { return item.letter })
        if (this.data.done) return
        console.log('dataIndex', dataIndex)
        console.log('quesIndex', quesIndex)
        this.$emit('checked', dataIndex, quesIndex, multipleChoiceRes)
      } else {
        questItem.list.map(val => {
          console.log('val---', val.content)
          if (itemData.content === val.content) {
            val.checked = !val.checked
          } else {
            val.checked = false
          }
          console.log('val---checked', val.checked)
        })
        const multipleChoice = questItem.list.filter(item => {
            if (item.checked) {
              return item
            }
        })
        const multipleChoiceRes = multipleChoice.map(item => { return item.letter })
        if (this.data.done) return
        this.$emit('checked', dataIndex, quesIndex, multipleChoiceRes)
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
// 66 + 36
.topics {
  .topic {
    padding-top: 16px;
    .topic_title {
      position: relative;
      margin-bottom: 16px;
      padding-left: 22px;
      &::after {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        background: #d5e3fd;
        border-radius: 50%;
        left: 6px;
        top: 8px;
      }
      &::before {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        background: #1564ff;
        border-radius: 50%;
        left: 0;
        top: 8px;
      }
    }
    .topic_content {
      padding-bottom: 16px;
      .topic_sub {
        display: flex;
        line-height: 26px;
        font-size: 16px;
        font-weight: bold;
      }
      .topic_option {
        margin-top: 16px;
        // margin-bottom: 32px;
        .topic_item {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          cursor: pointer;
          .circle {
            margin-right: 12px;
            text-align: center;
            border-radius: 50%;
            border: 1px solid #dcdfe6;
          }
        }
      }
      .topic_answer {
        padding: 16px;
        margin: 8px 0;
        background: #f9fafc;
        border-radius: 15px;
        .answer_title {
          margin-bottom: 16px;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
